$(function () {
    $(".button-watch-video").on("click", function (evt) {
        $(".video-modal").removeClass("hidden");
        $(".wrp-header").addClass("hidden");
        $("body").css("overflow", "hidden");
        playVideo()
    })
    
    $(".icona-chiudi-video").on("click", function (evt) {
        $(".video-modal").addClass("hidden");
        $(".wrp-header").removeClass("hidden");
        $("body").css("overflow", "auto");
        pauseVideo()
    })
})


function playVideo() {
    var player = document.querySelector("div.visualizzato iframe");
    player.contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
}

function pauseVideo() {
    var player = document.querySelector("div.visualizzato iframe");
    player.contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
}